import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OfferedLanguage } from 'src/app/interfaces/language.model';
import { Partner } from 'src/app/interfaces/partners';
import { ConfigService } from 'src/app/providers/config/config.service';
import { SkeletonServiceService } from '../../skeleton-service.service';
import { Observable } from 'rxjs';
import { slideOutLeft, slideInLeft } from 'src/app/utils/animation';
import { FooterLink } from 'src/app/interfaces/footer-link';
import { FOOTER_ABOUT_MENUS, FOOTER_AIDE_MENUS, FOOTER_INFO_MENUS, FOOTER_PARTNERS } from 'src/app/constants/footer-menu.constant';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  animations: [slideOutLeft, slideInLeft],
})
export class NavMenuComponent implements OnInit {
  @Input() partners: Partner[]
  @Output() closeSideMenu: EventEmitter<boolean> = new EventEmitter(false);
  @Output() langChange: EventEmitter<OfferedLanguage> = new EventEmitter();
  @Output() moveTop = new EventEmitter<boolean>(false);
  languagesOffered: OfferedLanguage[];
  footerAboutMenus: Array<FooterLink> = FOOTER_ABOUT_MENUS;
  footerInfoMenus: Array<FooterLink> = FOOTER_INFO_MENUS;
  footerAideMenus: Array<FooterLink> = FOOTER_AIDE_MENUS;
  // selectedLanguage: OfferedLanguage;
  selectedLanguage: Observable<OfferedLanguage>;
  modalState = "leave"
  constructor(private configService: ConfigService, private skeletonService: SkeletonServiceService, private router: Router) {
    this.selectedLanguage = skeletonService.appLanguage$.asObservable()
  }

  get isMobile() {
    return this.skeletonService.isMobile();
  }

  get socialMediaLinks() {
    return this.skeletonService.theme.socialMedia
  }


  get newPartners() {
    return this.configService.NewPartners
  }
  ngOnInit() {
    if(this.isMobile) {
      this.modalState = "enter";
    }
  }

  openPartner(partner: Partner) {
    this.configService.open(partner);
    if(this.isMobile){
      this.closeMenu();
    }
  }

  closeMenu(){
    this.closeSideMenu.emit(true);
  }

  openMiscInfo(activeTab) {
    let subPath = activeTab.id ? activeTab.id : null;
    if(activeTab.id === 'play-responsibly') {
      window.open(activeTab.link, '_blank');
      return;
    }

    if(subPath){
      this.moveTop.emit(true);
      this.router.navigate([activeTab.link, subPath]);
    }else {
      this.moveTop.emit(true);
      this.router.navigate([activeTab.link]);
    }

    if(this.isMobile){
      this.closeMenu();
    }
  }

  selectLanguage(lang: OfferedLanguage) {
    this.langChange.emit(lang);
  }
}
